import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import LocationsSelector from '@/configuration/components/LocationsSelector/LocationsSelector'

import { errorTypes } from '../constants'
import * as Styles from './styles'

const ShippingMethodSourceAddress = ({ location, onChange, errors }) => {
  const { t } = useTranslation()

  const handleChangeLocation = location => {
    onChange({ location })
  }

  const getRegionErrorType = () => {
    if (errors?.find(error => error.type === errorTypes.invalidLocationForCarrierService)) {
      return errorTypes.invalidRegionForCarrierService
    }

    if (errors?.find(error => error.type === errorTypes.locationIdEmpty)) {
      return errorTypes.locationIdEmpty
    }
  }

  return (
    <Styles.Container id={getRegionErrorType()}>
      <Text type="titleS">{t('Dirección de origen')}</Text>
      <LocationsSelector value={location} label={t('Ubicación')} onChange={handleChangeLocation} errors={errors} />
    </Styles.Container>
  )
}

export default ShippingMethodSourceAddress
